import { ACCOUNT_CHANGED } from "../actionTypes";
import { INTERNAL_BILATERAL_CONTRACT_NOTIFICATION_CHANGE, INTERNAL_BILATERAL_CONTRACT_RESULTS_RETRIEVED, INTERNAL_BILATERAL_CONTRACT_RETRIEVED, INTERNAL_BILATERAL_CONTRACTS_RESULTS_DIRECTION, INTERNAL_BILATERAL_CONTRACTS_RESULTS_ORDER_BY, INTERNAL_BILATERAL_CONTRACTS_RESULTS_PAGE_SIZE, INTERNAL_BILATERAL_SCHEDULE_RESULTS_DIRECTION, INTERNAL_BILATERAL_SCHEDULE_RESULTS_ORDER_BY, INTERNAL_BILATERAL_SCHEDULE_RESULTS_PAGE_SIZE, INTERNAL_BILATERAL_SCHEDULE_RESULTS_RETRIEVED, INTERNAL_BILATERAL_SEARCH_END_DATE, INTERNAL_BILATERAL_SEARCH_ISCONFIMRED, INTERNAL_BILATERAL_SEARCH_START_DATE } from "./InternalBilateralActionTypes";


const initialState = {
    contractResults: {},
    contractResultsPageSize: 10,
    contractResultsDirection: undefined,
    contractResultsOrderBy: undefined,
    scheduleResults: {},
    scheduleResultsPageSize: 10,
    scheduleResultsDirection: undefined,
    scheduleResultsOrderBy: undefined,
    selectedContract: { notifyNewSchedules: false },
    scheduleSearchStartDate: null,
    scheduleSearchEndDate: null,
    isConfirmed: true
}

const InternalBilateralRedcuer = (state = initialState, action) => {
    switch (action.type) {
        case INTERNAL_BILATERAL_CONTRACT_RESULTS_RETRIEVED:
            return { ...state, contractResults: action.contractResults };
        case INTERNAL_BILATERAL_CONTRACTS_RESULTS_DIRECTION:
            return { ...state, contractResultsDirection: action.contractResultsDirection };
        case INTERNAL_BILATERAL_CONTRACTS_RESULTS_ORDER_BY:
            return { ...state, contractResultsOrderBy: action.contractResultsOrderBy };
        case INTERNAL_BILATERAL_CONTRACTS_RESULTS_PAGE_SIZE:
            return { ...state, contractResultsPageSize: action.contractResultsPageSize };
        case INTERNAL_BILATERAL_SCHEDULE_RESULTS_RETRIEVED:
            return { ...state, scheduleResults: action.scheduleResults };
        case INTERNAL_BILATERAL_SCHEDULE_RESULTS_DIRECTION:
            return { ...state, scheduleResultsDirection: action.scheduleResultsDirection };
        case INTERNAL_BILATERAL_SCHEDULE_RESULTS_ORDER_BY:
            return { ...state, scheduleResultsOrderBy: action.scheduleResultsOrderBy };
        case INTERNAL_BILATERAL_SCHEDULE_RESULTS_PAGE_SIZE:
            return { ...state, scheduleResultsPageSize: action.scheduleResultsPageSize };
        case INTERNAL_BILATERAL_CONTRACT_RETRIEVED:
            return { ...state, selectedContract: action.selectedContract };
        case INTERNAL_BILATERAL_SEARCH_START_DATE:
            return { ...state, scheduleSearchStartDate: action.scheduleSearchStartDate };
        case INTERNAL_BILATERAL_SEARCH_END_DATE:
            return { ...state, scheduleSearchEndDate: action.scheduleSearchEndDate };
        case INTERNAL_BILATERAL_SEARCH_ISCONFIMRED:
            return { ...state, isConfirmed: !state.isConfirmed };
        case INTERNAL_BILATERAL_CONTRACT_NOTIFICATION_CHANGE:
            return { ...state, selectedContract: action.inscheduleContract };
        case ACCOUNT_CHANGED:
            return initialState;
        default: return state;
    }
}

export default InternalBilateralRedcuer;